export function templatefx() {
    return {
        contrast: 0,
        delay: 0,
        elevation: 1000,
        isMasked: false,
        isWait: false,
        occlusionAlpha: 0.5,
        occlusionMode: "3",
        opacity: 1,
        persistent: false,
        persistType: "sequencerground",
        playbackRate: 1,
        removeTemplate: false,
        repeat: 1,
        repeatDelay: 250,
        rotate: 0,
        saturate: 0,
        scale: "1",
        tint: false,
        tintColor: "#FFFFFF",
        zIndex: 1,
    }
}

/**
 * @typedef {object} DataTemplateFXOptions
 * 
 * @property {number}      delay -
 *
 * @property {number}      elevation -
 *
 * @property {boolean}     isMasked -
 *
 * @property {boolean}     isWait -
 *
 * @property {number}      occlusionAlpha -
 *
 * @property {number}      occlusionMode -
 *
 * @property {number}      opacity -
 *
 * @property {boolean}     persistent -
 *
 * @property {string}      persistType -
 *
 * @property {boolean}     removeTemplate -
 *
 * @property {number}      repeat -
 *
 * @property {number}      repeatDelay -
 *
 * @property {number}      rotate -
 *
 * @property {number}      scaleX -
 *
 * @property {number}      scaleY -
 *
 * @property {number}      zIndex -
 */
